var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq46(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22188,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.4582,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39.0457,
    y1: 12.1824,
    x2: 50.282,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.37185,
    y1: 49.8543,
    x2: 12.6082,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.8078,
    y1: 38.6199,
    x2: 50.0441,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.13401,
    y1: 0.944118,
    x2: 12.3703,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.476 27.62V26.878L22.572 20.018H23.734V26.766H25.232V27.62H23.734V30H22.768V27.62H17.476ZM22.81 21.096L18.61 26.766H22.81V21.096ZM32.2639 22.412C32.0586 21.1987 31.3539 20.592 30.1499 20.592C29.2353 20.592 28.5493 20.9467 28.0919 21.656C27.6346 22.3653 27.4246 23.5273 27.4619 25.142C27.6486 24.582 28.0033 24.1433 28.5259 23.826C29.0579 23.4993 29.6646 23.336 30.3459 23.336C31.3259 23.336 32.1006 23.6393 32.6699 24.246C33.2486 24.8433 33.5379 25.6693 33.5379 26.724C33.5379 27.34 33.4166 27.9 33.1739 28.404C32.9406 28.8987 32.5766 29.2953 32.0819 29.594C31.5966 29.8927 30.9899 30.042 30.2619 30.042C28.8713 30.042 27.9099 29.5987 27.3779 28.712C26.8553 27.8253 26.5939 26.57 26.5939 24.946C26.5939 21.4927 27.7793 19.766 30.1499 19.766C31.0459 19.766 31.7506 20.0133 32.2639 20.508C32.7773 20.9933 33.0806 21.628 33.1739 22.412H32.2639ZM30.1639 24.176C29.7253 24.176 29.3099 24.2647 28.9179 24.442C28.5259 24.6193 28.2039 24.89 27.9519 25.254C27.7093 25.6087 27.5879 26.0473 27.5879 26.57C27.5879 27.326 27.8119 27.956 28.2599 28.46C28.7079 28.964 29.3613 29.216 30.2199 29.216C30.9386 29.216 31.5126 28.9967 31.9419 28.558C32.3713 28.1193 32.5859 27.522 32.5859 26.766C32.5859 25.954 32.3759 25.3193 31.9559 24.862C31.5359 24.4047 30.9386 24.176 30.1639 24.176Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq46);
export default __webpack_public_path__ + "static/media/fq46.1887d23307ca8b54c7c81c767063f2cc.svg";
export { ForwardRef as ReactComponent };